/** @file quadHandlesOf: this frame's quad handles input (the selected part's quad in the quads view). */
import type { QuadHandlesInput } from './quadHandles';
import { docEntryOf } from './docEntryOf';
import type { QuadGeom } from './quadGeomOf';
import { quadPoint } from './quadPoint';
import { selectedQuad } from './selectedQuad';
import { shownTileOf } from './shownTileOf';
import type { ViewportCtx } from './viewportCtx';

/** The midpoint of the edge holding the image's top row (the parent-joint end of a `rotate: parent` quad). */
const topOf = (g: QuadGeom): [number, number] => quadPoint(g.corners, 0.5, g.flip[1] ? 1 : 0);

/**
 * The handle points of `selectedQuad`, the dragged (else hovered) handle, the view and `px`, and the parent-end marker
 * when the entry the part shows rotates with its parent; null without a selected quad.
 */
export function quadHandlesOf(ctx: ViewportCtx, px: number): QuadHandlesInput | null {
  const q = selectedQuad(ctx);
  if (q === null || ctx.scene === null) return null;
  const ref = shownTileOf(ctx, q.drawableIndex);
  const parent = ref !== null && docEntryOf(ctx.store, ref)?.rotate === 'parent';
  return { points: q.points, hover: ctx.quad.edit?.handle ?? ctx.quad.handle, view: ctx.scene.camera.view(), px, top: parent ? topOf(q.geom) : null };
}
